import {useSyncExternalStore} from 'react'

import styles from './Universe26Banner.module.css'

const pad = (value: number) => String(value).padStart(2, '0')

export function formatCountdown(remainingMs: number): string {
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000))
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const time = `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`
  return days > 0 ? `${days}d ${time}` : time
}

function subscribe(onTick: () => void) {
  const id = setInterval(onTick, 1000)
  return () => clearInterval(id)
}

// Whole seconds keep consecutive snapshots equal within a tick.
const getNowInSeconds = () => Math.floor(Date.now() / 1000)

/**
 * The server snapshot is empty so SSR and hydration markup match; the client fills in the remaining
 * time right after hydration. The slot reserves its width until then.
 */
export function Countdown({to}: {to: string}) {
  const nowInSeconds = useSyncExternalStore(subscribe, getNowInSeconds, () => null)

  return (
    <span className={styles.countdown}>
      {nowInSeconds === null ? null : formatCountdown(Date.parse(to) - nowInSeconds * 1000)}
    </span>
  )
}
